export const getSaleCategories = ({ data, dataToAdd, categoryToExtract }) => {
  if (!data) return [];
  const clone = [...data];
  const selectedCategory = clone?.find((item) => item?.name === categoryToExtract);
  if (!selectedCategory) return [];
  if (!dataToAdd) return selectedCategory?.child;
  return [...selectedCategory?.child, ...dataToAdd];
};
